"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _config = _interopRequireDefault(require("../../../config/"));
var _Snackbar = _interopRequireDefault(require("../Snackbar/Snackbar"));
require("./APSnackbar.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APSnackbar = /*#__PURE__*/function (_Component) {
  function APSnackbar() {
    var _this;
    _classCallCheck(this, APSnackbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, APSnackbar, [].concat(args));
    _defineProperty(_this, "bemClasses", (0, _cssClassesHelper.getBEMClasses)(['ap-snackbar']));
    return _this;
  }
  _inherits(APSnackbar, _Component);
  return _createClass(APSnackbar, [{
    key: "closeSnack",
    value: function closeSnack(snack) {
      this.props.dismissSnackByUniqueId(snack.uniqueId);
      snack.onClose && snack.onClose();
    }
  }, {
    key: "getSnackElement",
    value: function getSnackElement(snack) {
      var _this2 = this;
      var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var timeout = snack.timeout || _config["default"].Snackbar.timeout;
      var animationTimeout = Math.round(timeout / 1000);
      setTimeout(function () {
        return _this2.closeSnack(snack);
      }, timeout);
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: idx,
        className: this.bemClasses('snack')
      }, /*#__PURE__*/_react["default"].createElement(_Snackbar["default"], _extends({}, snack, {
        onClose: function onClose() {
          return _this2.closeSnack(snack);
        }
      })), _config["default"].Snackbar.showProgressBar && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.bemClasses('snack-progress'),
        style: {
          animationDuration: "".concat(animationTimeout, "s")
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_reactDom["default"].createPortal(/*#__PURE__*/_react["default"].createElement("div", {
        className: this.bemClasses()
      }, _config["default"].Snackbar.showMultiple && this.props.snacks.map(function (snack, idx) {
        return _this3.getSnackElement(snack, idx);
      }), !_config["default"].Snackbar.showMultiple && this.props.snacks[0] && this.getSnackElement(this.props.snacks[0])), document.body);
    }
  }]);
}(_react.Component);
_defineProperty(APSnackbar, "defaultProps", {
  timeout: _config["default"].Snackbar.timeout,
  snacks: []
});
_defineProperty(APSnackbar, "propTypes", {
  timeout: _propTypes["default"].number,
  snacks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    timeout: _propTypes["default"].number,
    text: _propTypes["default"].string.isRequired,
    textVars: _propTypes["default"].object,
    id: _propTypes["default"].string.isRequired,
    type: _propTypes["default"].oneOf(['info', 'success', 'warning']),
    customClass: _propTypes["default"].string,
    onClose: _propTypes["default"].func
  })).isRequired
});
var _default = exports["default"] = APSnackbar;